import { BACKEND_ORIGIN, BOOKING_STATUS_LABELS } from './constants';

/** Turns a stored "/uploads/x.jpg" path into an absolute URL; passes through absolute URLs. */
export const fileUrl = (path) => {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  return `${BACKEND_ORIGIN}${path.startsWith('/') ? '' : '/'}${path}`;
};

export const fullName = (u) =>
  [u?.firstName, u?.lastName].filter(Boolean).join(' ') || u?.email || 'Unknown';

export const currency = (amount, code = 'USD') => {
  if (amount === null || amount === undefined || amount === '') return '—';
  return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(Number(amount));
};

export const rating = (value) => (value ? Number(value).toFixed(1) : 'New');

export const dateTime = (iso) => {
  if (!iso) return '—';
  return new Date(iso).toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
};

export const dateOnly = (iso) => {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString(undefined, { dateStyle: 'medium' });
};

/** For <input type="datetime-local"> — local time, no seconds/zone. */
export const toDatetimeLocalValue = (date = new Date()) => {
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const bookingStatusLabel = (status) => BOOKING_STATUS_LABELS[status] || status;

export const relativeTime = (iso) => {
  if (!iso) return '';
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.round(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  return `${days}d ago`;
};
